import React from "react";
import { Spinner } from "react-bootstrap";
import StatusRecord from "./StatusRecord";

export default function StatusTimeline({ loading, records }) {
  if (loading) {
    return (
      <div className="text-center py-4">
        <Spinner animation="border" />
      </div>
    );
  }

  if (records.length === 0) {
    return (
      <div className="text-center text-muted py-4">
        История отсутствует
      </div>
    );
  }

  return (
    <div className="timeline">
      {records.map((record, index) => (
        <StatusRecord key={index} record={record} />
      ))}
    </div>
  );
}